import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IRoutingFilterResult } from './RoutingFilterTypes';

export interface IDeleteRoutingFilterParams {
  siteId: string;
  routingRuleId: string;
}

export class DeleteRoutingFilterRequest extends Request<IDeleteRoutingFilterParams, IRoutingFilterResult> {
  constructor(params: IDeleteRoutingFilterParams) {
    super('deleteRoutingRule', params);
  }
}
